<div class="wrapper mb-5">
    <!-- <sv-react-units-list></sv-react-units-list> -->
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Unidades</span>
        <button class="action-button ml-2 my-1" (click)="create()">Nova Unidade</button>
    </div>
    <div class="component-box container-fluid">
        <div>
        </div>
        <div class="row container-fluid pt-4">
            <div class="col-12 text-right">
                <ul class="options-cadastro">
                    <li>
                        <div class="list-select mr-4 my-1">
                            <button class="list-select" (click)="selectAllToDelete(selectAll = !selectAll);">Selecionar tudo</button>
                        </div>
                    </li>
                    <li>
                        <div *ngIf="deleteCount > 0" class="list-select mr-4 my-1">
                            <button class="list-select-delete" (click)="showDeleteAll(deleteallmodal);">Excluir</button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select mr-4 my-1">
                            <button type="button" class="list-select" (click)="showFilter(filtro)">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input mr-42 my-1">
                            <input class="w-100" type="search" placeholder="Pesquise aqui..."#search (input)="searchFilter(search.value)" />
                        </div>
                    </li>
                    <li>
                        <div class="list-filter-show-item ml-2 my-1">Mostrar:
                            <select [(ngModel)]="showItem">
                                <option [ngValue]="10" value="10" selected>10</option>
                                <option [ngValue]="25" value="25">25</option>
                                <option [ngValue]="50" value="50">50</option>
                                <option [ngValue]=100 value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>
        </div>



        <div class="table-overflow mx-2">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th></th>
                    <th class="" (click)="sortOrder = !sortOrder; orderBy('codigo', sortOrder)">Código</th>
                    <th class="" (click)="sortOrder = !sortOrder; orderBy('nome', sortOrder)">Nome</th>
                    <th class="" (click)="sortOrder = !sortOrder; orderBy('status', sortOrder)">Status</th>
                    <th class="" (click)="sortOrder = !sortOrder; orderBy('limite', sortOrder)">limite</th>
                    <th></th>
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="let item of unidadesList | paginate: { itemsPerPage: showItem, currentPage: currentPage }"
                        class=" list-table-cell">
                        <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                            <span class="mx-2">
                                <input [attr.id]="item.unidadeId" type="checkbox" class="radio-checkbox"
                                    [(ngModel)]="item.toDelete"
                                    (click)="item.toDelete = !item.toDelete; updateDeleteCount();" />
                                <label [attr.for]="item.unidadeId" class="radio-label"></label>
                            </span>
                        </td>
                        <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">{{item.codigo}}
                        </td>
                        <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">{{item.nome}}
                        </td>
                        <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                            {{Status[item.status]}}</td>
                        <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">{{item.limite}}
                        </td>

                        <td>
                            <div ngbDropdown class="d-inline-block menu-option">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                        src="assets/icons/menu.png" /></button>
                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div ngbDropdownItem (click)="edit(item)"><img src="assets/icons/pencil-purple.png"
                                                class="mr-2" />Editar</div>
                                        <div ngbDropdownItem (click)="showDelete(deletemodal,item);"><img
                                                src="assets/icons/garbage-purple.png" class="mr-2" />Excluir</div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="page-custom mt-2">
                <pagination-controls (pageChange)="currentPage = $event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar Filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>Código</mat-label>
                <input [formControl]="codeCtrl" matInput type="text" [(ngModel)]="filtroCodigo" id="codigo">
                <button mat-button *ngIf="filtroCodigo" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCodigo=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <mat-form-field class="w-100">
                <mat-label>Nome</mat-label>
                <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="nome">
                <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <!-- <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="codigo">Código:</label>
                <input #codigo class="clean-filter-input" type="text" [(ngModel)]="filtroCodigo" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="nome">Nome:</label>
                <input #nome class="clean-filter-input" type="text" [(ngModel)]="filtroNome" />
            </div>
        </div> -->
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

<!--Modal do Deletar-->
<ng-template #deletemodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Deletar Centro de Custo</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja excluir a unidade:
            <span style="color:#313840; font-weight: bold;">{{unidadeToDelete.nome}}?</span>
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="delete(unidadeToDelete);modal.dismiss('Close click')">
            Excluir
        </button>
    </div>
</ng-template>

<!--Modal do Deletar Vários-->
<ng-template #deleteallmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Deletar Centros de Custo</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja excluir {{deleteCount}} unidade(s)?
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button" [disabled]="deleteCount < 1" (click)="deleteAllSelected();modal.dismiss('Close click')">
            Excluir
        </button>
    </div>
</ng-template>
